import { render, staticRenderFns } from "./QualityRecords.vue?vue&type=template&id=e462875e&scoped=true"
import script from "./QualityRecords.vue?vue&type=script&lang=js"
export * from "./QualityRecords.vue?vue&type=script&lang=js"
import style0 from "./QualityRecords.vue?vue&type=style&index=0&id=e462875e&prod&lang=css"
import style1 from "./QualityRecords.vue?vue&type=style&index=1&id=e462875e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e462875e",
  null
  
)

export default component.exports